import { BREEDING_GRADES } from "./constants";

export const BasicInfoSection = ({ formData, update, breederProfile, isStud, isMare, isStudOrMare }) => (
  <div className="glass-card p-6 space-y-6">
    <h2 className="text-xl text-[#EDEDED] mb-4">Basic Information</h2>

    <div>
      <label className="block text-sm text-[#A1A1AA] mb-2">
        {isStudOrMare ? `${isStud ? "Stud" : "Mare"} Name *` : "Listing Title *"}
      </label>
      <input
        type="text"
        value={isStudOrMare ? formData.animal_name : formData.title}
        onChange={(e) => {
          const v = e.target.value;
          if (isStudOrMare) {
            update({ animal_name: v, title: `${v} - ${formData.breed || "Breeding Service"}` });
          } else {
            update({ title: v });
          }
        }}
        className="input-minimal"
        placeholder={isStudOrMare ? "e.g., Champion Thunderbolt" : "e.g., Registered Quarter Horse Foal"}
        required
      />
    </div>

    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Species *</label>
        <select
          value={formData.species}
          onChange={(e) => update({ species: e.target.value })}
          className="input-minimal bg-transparent"
          required
        >
          <option value="">Select...</option>
          {breederProfile.species?.map((s) => (
            <option key={s} value={s}>
              {s.charAt(0).toUpperCase() + s.slice(1)}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">
          {isStudOrMare ? "Service Fee (USD) *" : "Price (USD) *"}
        </label>
        <input
          type="number"
          value={formData.price}
          onChange={(e) => update({ price: e.target.value })}
          className="input-minimal"
          placeholder="0.00"
          required
        />
      </div>
    </div>

    {formData.species === "exotics" && (
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Exotic Subtype *</label>
        <select
          value={formData.exotic_subtype}
          onChange={(e) => update({ exotic_subtype: e.target.value })}
          className="input-minimal bg-transparent"
          required
        >
          <option value="">Select...</option>
          <option value="birds">Birds</option>
          <option value="miniature_primates">Miniature Primates</option>
        </select>
      </div>
    )}

    <div>
      <label className="block text-sm text-[#A1A1AA] mb-2">Breed *</label>
      <input
        type="text"
        value={formData.breed}
        onChange={(e) => update({ breed: e.target.value })}
        className="input-minimal"
        placeholder="e.g., Quarter Horse, French Bulldog"
        required
      />
    </div>

    <div className="grid grid-cols-3 gap-4">
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Age</label>
        <input
          type="text"
          value={formData.age}
          onChange={(e) => update({ age: e.target.value })}
          className="input-minimal"
          placeholder="e.g., 2 years"
        />
      </div>
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Sex</label>
        <input
          type="text"
          value={formData.sex}
          onChange={(e) => update({ sex: e.target.value })}
          className="input-minimal"
          placeholder={isStud ? "stallion" : isMare ? "mare" : "e.g., male"}
        />
      </div>
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Color</label>
        <input
          type="text"
          value={formData.color}
          onChange={(e) => update({ color: e.target.value })}
          className="input-minimal"
          placeholder="e.g., bay, fawn"
        />
      </div>
    </div>

    {isStudOrMare && (
      <div>
        <label className="block text-sm text-[#A1A1AA] mb-2">Breeding Grade</label>
        <select
          value={formData.breeding_grade}
          onChange={(e) => update({ breeding_grade: e.target.value })}
          className="input-minimal bg-transparent"
        >
          {BREEDING_GRADES.map((g) => (
            <option key={g.value} value={g.value}>
              {g.label}
            </option>
          ))}
        </select>
      </div>
    )}
  </div>
);
